module.exports = __webpack_public_path__ + "img/Kibe47.6afad0ab.jpg";